import { render, staticRenderFns } from "./ShopSuggest.vue?vue&type=template&id=bbe14044&"
import script from "./ShopSuggest.vue?vue&type=script&lang=ts&"
export * from "./ShopSuggest.vue?vue&type=script&lang=ts&"
import style0 from "./ShopSuggest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports